import { css } from 'styled-components';
import { convertToDarkerRgba } from './convertToDarkerRgba';
import { linkEffect } from './linkEffect';
export const linkEffectForChildren = () => css `
  a {
    ${linkEffect}
    /* Needed to force the color */
    color: ${({ theme }) => theme === null || theme === void 0 ? void 0 : theme.colors.link} !important;

    &:hover {
      color: ${({ theme }) => convertToDarkerRgba(theme === null || theme === void 0 ? void 0 : theme.colors.link)} !important;
    }
  }
`;
//# sourceMappingURL=linkEffectForChildren.js.map